import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {AuthenticationPanel} from "../AuthenticationPanel";
import {Messages} from "../../../../Messages";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {BasePanelPageStyle} from "../BasePanelPage";


class DonationAuthenticationPanelStyle extends BasePanelPageStyle {
    @styleRule
    message = this.themeProps.PANEL_MESSAGE_STYLE;
}

@registerStyle(DonationAuthenticationPanelStyle)
export class DonationAuthenticationPanel extends AuthenticationPanel {
    render() {
        return [
            Messages.authHomeDonation.toString().trim() ?
                <MessageElement message={Messages.authHomeDonation(iFrameMerchantService.getMerchant().name)}
                                className={this.styleSheet.message}/> : null,
            super.render()
        ];
    }
}
